var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileRecognition.jinja');
require('./MemberProfileRecognition.less');

var Inner = require('front/components/MemberProfile/MemberProfileRecognitionInner');
var Runtime = require('front/components/MemberProfile/MemberProfileRecognitionInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateBlock');

        window.app.vent.on('MemberProfile--updateRecognition', this.updateBlock);

        this.Inner = new Inner({
            el: this.$('.MemberProfileRecognitionInner')[0]
        });

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfile--updateRecognition', this.updateBlock);

        this.Inner.deactivate();
        delete this.Inner;

        return Base.prototype.deactivate.call(this, params);
    },


    updateBlock: function (memberId) {
        this.Inner.deactivate();
        delete this.Inner;

        var data = window.app.data.members[memberId];

        var $template = $(Runtime.render({
            data: window.app.data.members[memberId],
            isOwner: window.app.settings.member == memberId
        }));

        this.$('.MemberProfileRecognition-wrapper').html($template);

        this.Inner = new Inner({
            el: this.$('.MemberProfileRecognitionInner')[0]
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileRecognition.js
// module id = 202
// module chunks = 0